import { render, staticRenderFns } from "./SchoolAlternativeItem.vue?vue&type=template&id=1e10d28e&scoped=true"
import script from "./SchoolAlternativeItem.vue?vue&type=script&lang=js"
export * from "./SchoolAlternativeItem.vue?vue&type=script&lang=js"
import style0 from "./SchoolAlternativeItem.vue?vue&type=style&index=0&id=1e10d28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e10d28e",
  null
  
)

export default component.exports